import { render, staticRenderFns } from "./WelcomeHeaderChannelUser.vue?vue&type=template&id=23ea2040&"
import script from "./WelcomeHeaderChannelUser.vue?vue&type=script&lang=js&"
export * from "./WelcomeHeaderChannelUser.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeHeaderChannelUser.vue?vue&type=style&index=0&id=23ea2040&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports